import { Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import MFooter from "../../../../Components/Mobile/MFooter/MFooter";
import MNavbar from "../../../../Components/Mobile/MNavbar/MNavbar";
import MRequestDemo from "../../../../Components/Mobile/MRequestDemo/MRequestDemo";
import "./../MProductPages.scss";

interface MIntegrationExcellenceProps {
    journey: {
        head: string;
        content: string;
    }[];
    why_choose: {
        img: string;
        title: string;
        desc: string;
    }[];
    carousel_responsive: {
        mobile: {
            breakpoint: { max: number; min: number };
            items: number;
            slidesToSlide: number;
        };
    };
}

const MIntegrationExcellence = ({
    journey,
    why_choose,
    carousel_responsive,
}: MIntegrationExcellenceProps) => {

    return (
        <>
            <MNavbar />

            <Box className="productpage-wrapper">
                <Box
                    className="prouct-header"
                    padding={"0px 12px"}
                    marginBottom={"40px"}
                >
                    <Grid
                        container
                        rowSpacing={0}
                        columnSpacing={3}
                        paddingTop={"40px"}
                        paddingBottom={"16px"}
                    >
                        <Grid xs={12} textAlign={"center"} marginBottom={"20px"}>
                            <h2>Welcome to Insurvent – Unleashing Seamless
                                <span> Integration Excellence </span>
                                for Sales Partners and Insurance Companies!
                            </h2>
                        </Grid>
                        <Grid xs={12} textAlign={"center"}>
                            <Box className="product_header_img">
                                <img src="./images/integration_excellence_header.svg" alt="integration_excellence_header" />
                            </Box>
                        </Grid>
                    </Grid>
                </Box>

                <Box
                    className="product_info_section"
                    padding={"0px 12px"}
                    marginBottom={"40px"}
                >
                    <Grid container rowSpacing={0} columnSpacing={3}>
                        <Grid xs={12} textAlign={"center"} marginBottom={"12px"}>
                            <Box className="inner_box">
                                <img
                                    src="./images/integration_desc_img.svg"
                                    alt="integration_desc_img"
                                    style={{ maxHeight: "250px" }}
                                />
                                <h3 className="mb-2 mt-3">
                                    Integration Support Hub:<span> Elevating Sales Partners</span>
                                </h3>
                                <p>
                                    At Insurvent, we recognize the pivotal role our Sales Partners play in shaping success within the competitive insurance landscape. Our Integration Support Hub is more than just a resource – it's a commitment to empowering you with seamless tools, personalized resources, and unwavering support. Whether you're a large agency or an individual agent, our goal is to enhance your capabilities, simplify processes, and elevate your journey to unparalleled success.
                                </p>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>

                <Box
                    marginBottom={"40px"}
                    padding={"0px 12px"}
                    className="integration_journey"
                >
                    <Grid container columnSpacing={3} className="row">
                        <Grid xs={12}>
                            <h3 className="heading mb-6 text-center">
                                Empowering<span> Your Journey</span>
                            </h3>
                        </Grid>
                        <Grid xs={12}>
                            <Box>
                                <Carousel
                                    swipeable={true}
                                    draggable={true}
                                    showDots={true}
                                    responsive={carousel_responsive}
                                    infinite={true}
                                    autoPlay={true}
                                    removeArrowOnDeviceType={["tablet", "mobile"]}
                                    autoPlaySpeed={3000}
                                    arrows={false}
                                    customTransition={"transform 800ms ease-in-out"}
                                >
                                    {journey?.map((data, i) => (
                                        <Box className="carousel_part">
                                            <h6>{data.head}</h6>
                                            <p>{data.content}</p>
                                        </Box>
                                    ))}
                                </Carousel>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>

                <Box
                    marginBottom={"40px"}
                    padding={"0px 12px"}
                    className="integration_advantage"
                >
                    <Grid container columnSpacing={3} className="row">
                        <Grid xs={12} textAlign={"center"}>
                            <h3>
                                Why Choose
                                <span> Insurvent </span>
                            </h3>
                        </Grid>
                        <Grid xs={12}>
                            <Carousel
                                swipeable={true}
                                draggable={true}
                                showDots={true}
                                responsive={carousel_responsive}
                                infinite={true}
                                autoPlay={true}
                                removeArrowOnDeviceType={["tablet", "mobile"]}
                                autoPlaySpeed={3000}
                                arrows={false}
                                customTransition={"transform 800ms ease-in-out"}
                            >
                                {why_choose?.map((data, i) => (
                                    <Box className="choosing">
                                        <span>0{i + 1}</span>
                                        <h6>{data.title}</h6>
                                        <p>{data.desc}</p>
                                        <img style={{ margin: '24px auto 0', padding: '10px' }} src={data.img} alt="d" />
                                    </Box>
                                ))}
                            </Carousel>
                        </Grid>
                    </Grid>
                </Box>

                <Box marginBottom={"40px"} padding={"0px 12px"}>
                    <Grid container columnSpacing={3} className="row">
                        <Grid xs={12}>
                            <Box
                                sx={{
                                    background: "#F3F2FC",
                                    borderRadius: "12px",
                                    padding: "12px",
                                }}
                            >
                                <p style={{ textAlign: "center" }}>
                                    Join Insurvent's Integration Hub with confidence, knowing that we are committed to elevating your success. From Sales Partners to Insurance Companies, we welcome you to a partnership where innovation seamlessly meets reliability for a future-proofed journey in the dynamic insurance landscape.
                                </p>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>

                <MRequestDemo heading={"Get"} />

            </Box>

            <MFooter />
        </>
    )
}

export default MIntegrationExcellence